var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 17.999,
    viewBox: "0 0 18 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.057,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515b7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-active",
    x1: 1,
    y1: 0.039,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca79ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#ffe4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76daff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Attendance",
    "data-name": "Icon/Attendance",
    transform: "translate(-26.002 -170.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M1.5,18a1.541,1.541,0,0,1-1.051-.405A1.216,1.216,0,0,1,0,16.653V2.7a1.222,1.222,0,0,1,.449-.948A1.541,1.541,0,0,1,1.5,1.347H3.121V.695A.648.648,0,0,1,3.348.2.82.82,0,0,1,3.925,0,.855.855,0,0,1,4.51.2a.66.66,0,0,1,.24.515v.633h8.5V.695a.646.646,0,0,1,.225-.5A.8.8,0,0,1,14.05,0a.865.865,0,0,1,.589.2.648.648,0,0,1,.234.515v.633H16.5a1.542,1.542,0,0,1,1.053.405A1.247,1.247,0,0,1,18,2.7V16.653a1.241,1.241,0,0,1-.447.941A1.542,1.542,0,0,1,16.5,18Zm0-1.346h15V4.474H1.5Zm5.828-1.781A4.594,4.594,0,0,1,4.868,12.4,4.343,4.343,0,0,1,4.5,10.618a4.4,4.4,0,0,1,.372-1.794,4.6,4.6,0,0,1,2.459-2.46,4.571,4.571,0,0,1,3.58,0,4.651,4.651,0,0,1,1.472.989,4.705,4.705,0,0,1,.995,1.471,4.5,4.5,0,0,1,.366,1.794,4.44,4.44,0,0,1-.366,1.787,4.627,4.627,0,0,1-2.467,2.467,4.583,4.583,0,0,1-3.58,0Zm1.58-6.618a.337.337,0,0,0-.1.247v2.117a.252.252,0,0,0,.029.124.291.291,0,0,0,.068.116L10.57,12.59a.344.344,0,0,0,.5-.013.327.327,0,0,0,.11-.253.359.359,0,0,0-.1-.262L9.5,10.481V8.5a.34.34,0,0,0-.1-.241.358.358,0,0,0-.248-.1A.337.337,0,0,0,8.907,8.254Z",
    transform: "translate(26.002 170.002)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceIcon);
export default __webpack_public_path__ + "static/media/AttendanceIcon.8fbfc2696f2e7a9e96e7d90092da35b7.svg";
export { ForwardRef as ReactComponent };